/* eslint-disable react/boolean-prop-naming */
import type { ReactNode } from 'react'
import type { ModalProps } from 'flowbite-react'
import { Modal } from 'flowbite-react'
import HSButton from 'components/button'

interface IModalComponent extends ModalProps {
	openModal: boolean
	onClose: () => void
	header?: string
	children: ReactNode
	buttons?: {
		text: string
		onClick: () => void
		color?: string
		disabled?: boolean
	}[]
	hideCloseButton?: boolean
}

const HSModal = (properties: IModalComponent) => {
	const {
		openModal,
		onClose,
		header = '',
		buttons,
		children,
		hideCloseButton,
		...rest
	} = properties

	const customTheme = {
		header: {
			close: {
				base: `ml-auto inline-flex ${hideCloseButton ? 'hidden' : ''} items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white`
			}
		}
	}

	return (
		<Modal show={openModal} onClose={onClose} {...rest} theme={customTheme}>
			<Modal.Header>
				<div className='text-lg font-semibold text-gray-900'>{header}</div>
			</Modal.Header>
			<Modal.Body className='p-0'>{children}</Modal.Body>
			{Number(buttons?.length) > 0 ? (
				<Modal.Footer>
					<div className='flex w-full flex-row-reverse items-end justify-center gap-2'>
						{buttons?.map((button, index) => (
							<HSButton
								// eslint-disable-next-line react/no-array-index-key
								key={index}
								onClick={button.onClick}
								color={button.color ?? 'primary'}
								disabled={button.disabled}
								className='w-full'
							>
								{button.text}
							</HSButton>
						))}
					</div>
				</Modal.Footer>
			) : null}
		</Modal>
	)
}

export default HSModal
